import type { LinkView } from 'features/libra/dashboard/ticketDashboard/types'
import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import { createLibraSearch } from 'routes/libra/-searchParams'

/** Tickets without an organization tag can't be opened, so they get no link. */
export function ticketLink(
  ticket: LibraTicket,
  label: string,
  threadId?: string
): LinkView | undefined {
  const orgId = ticket.tags.organization
  if (typeof orgId !== 'string' || !orgId) return undefined
  return {
    label,
    to: '/libra',
    search: createLibraSearch({
      orgId,
      workflowId: ticket.workflowId,
      ticket: ticket.id,
      thread: threadId,
    }),
  }
}
